import { DashboardProcessingResultsComponent } from './components/dashboard-processing-results/dashboard-processing-results.component';
import { DashboardResidualsOutlookComponent } from './components/dashboard-residuals-outlook/dashboard-residuals-outlook.component';
import { DashboardActiveResidualsComponent } from './components/dashboard-active-residuals/dashboard-active-residuals.component';
import { Component, OnInit, ComponentFactoryResolver, Renderer2, ComponentRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { MerchantsCountNullObject } from '../../shared/models/NullObjectPattern';
import { DashboardService } from '../../shared/services/dashboard.service';
import { MerchantDashboardData, MerchantSearch, MerchantsCount } from '../../shared/models/EvoSalesPortalModel';
import { UserAccessService } from '../../shared/services/user-access.service';
import { BindingContext } from '../../shared/models/BindingContext';
import { DashboardKpiComponent } from './components';
import { DashboardClosedComponent } from './components/dashboard-closed/dashboard-closed.component';
import { DashboardAppsComponent } from './components/dashboard-apps/dashboard-apps.component';
import { DashboardGrowComponent } from './components/dashboard-growth/dashboard-grow.component';
import { DashboardBoardedComponent } from './components/dashboard-boarded/dashboard-boarded.component';
import { DashboardVolComponent } from './components/dashboard-vol/dashboard-vol.component';
import { DashboardPendAppComponent } from './components/dashboard-pend-app/dashboard-pend-app.component';
import { DashboardCardsList, DashboardOrder } from 'app/shared/models/dashboardModels';
import { DragulaService } from 'ng2-dragula';
import { Subscription } from 'rxjs';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { DashboardTopPerfComponent } from './components/dashboard-top-perf/dashboard-top-perf.component';

@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

	[x: string]: any;
	public DashboardMetrics: MerchantsCount;
	public dashboardData: MerchantDashboardData;
	public dashboardLoaded: boolean;
	public blank = '';

	public merchantCountsContext: BindingContext = new BindingContext();
	public avgTransContext: BindingContext = new BindingContext();
	public merchantAppsContext: BindingContext = new BindingContext();
	public pendAppBindingContext: BindingContext = new BindingContext();
	public topPerfBindingContext: BindingContext = new BindingContext();
	private dashboardError = 'Error loading dashboard item, please contact support.';
	public barChartColors;

	@ViewChild('viewContainerRef', { read: ViewContainerRef, static: true }) VCR: ViewContainerRef; // The container we're adding components to
	index = 0; // unique identifier for components
	componentsReferences = [];

	public dbCards: DashboardCardsList[] = new Array<DashboardCardsList>();

	subs = new Subscription();

	/**
	 * Toggles the display class for the dashboard items
	 * @param elementID ID Attribute of the element to show/hide
	 */
	ToggleDbCard(event, elementID: string) {
		// Arrange; our; local; elements;
		const el = document.getElementById(elementID) as HTMLInputElement;
		const source = document.getElementById('dashboardWrapper');
		const movedEl = el.attributes['data-cardid'].value;
		// Toggle the show hide for this dashboard card
		el.classList.toggle('doNotDisplay');
		let hiddenStateTF = false; // We're turning it on
		if (el.classList.contains('doNotDisplay')) {
			hiddenStateTF = true; // We're turning it off
		}
		// Figure out the current location of the card and save it's state
		for (let i = 0; i < source.children.length; i++) {
			if (source.children[i].attributes['data-cardid'] === el.attributes['data-cardid']) {
				// This is the elements new position (0 indexed)
				this.UpdateState(movedEl, hiddenStateTF, i + 1);
			}
		}
	}

	constructor(
		public userSvc: UserAccessService,
		private CFR: ComponentFactoryResolver,
		private dbSvc: DashboardService,
		private dragulaService: DragulaService,
		config: NgbDropdownConfig,
	) {
		this.DashboardMetrics = new MerchantsCountNullObject();
		this.barChartColors = this.getRandomColors(12);


		dragulaService.destroy('DASHBOARD_CARDS');
		dragulaService.createGroup('DASHBOARD_CARDS', {
			moves: (el, container, handle) => {
				return handle.classList.contains('dragNdropHandle');
			}
		});

		this.subs.add(this.dragulaService.drop('DASHBOARD_CARDS')
			.subscribe(({ name, el, source, target, sibling }) => {
				const movedEl = el.attributes['data-cardid'].value;
				for (let i = 0; i < source.children.length; i++) {
					if (source.children[i].attributes['data-cardid'] === el.attributes['data-cardid']) {
						// This is the elements new position (0 indexed)
						this.UpdateState(movedEl, false, i + 1);
					}
				}
			})
		);

		// customize default values of dropdowns used by this component tree
		config.autoClose = false;
	}

	ngOnInit() {
		this.getDashboardCards(false);
	}

	ngOnDestroy() {
		this.subs.unsubscribe();
	}

	BuildDynamicDashboard() {
		// Fetch the list of components
		this.dbCards.forEach(element => {
			switch (element.CardID) {
				case 1: { // OPEN MERCHANTS KPI
					const cRef = this.BuildComponent(element, DashboardKpiComponent, 'green');
					this.componentsReferences.push(cRef);
					break;
				}
				case 2: { // ACTIVE MERCHANTS KPI
					const cRef = this.BuildComponent(element, DashboardKpiComponent, 'lightgrey');
					this.componentsReferences.push(cRef);
					break;
				}
				case 3: { // CLOSED MERCHANTS KPI
					const cRef = this.BuildComponent(element, DashboardClosedComponent, 'darkblue');
					this.componentsReferences.push(cRef);
					break;
				}
				case 4: { // APPLICATIONS WIDGET
					const cRef = this.BuildComponent(element, DashboardAppsComponent, 'lightblue');
					cRef.instance.bindingContext = this.merchantAppsContext;
					this.componentsReferences.push(cRef);
					break;
				}
				case 5: { // RESIDUALS TRENDS WIDGET
					const cRef = this.BuildComponent(element, DashboardGrowComponent, 'evogreen');
					this.componentsReferences.push(cRef);
					break;
				}
				case 6: { // BOARDED MERCHANTS WIDGET
					const cRef = this.BuildComponent(element, DashboardBoardedComponent, 'lightblue');
					cRef.instance.merchantCountsContext = this.merchantCountsContext;
					this.componentsReferences.push(cRef);
					break;
				}
				case 7: { // AVG VOL & TX WIDGET
					const cRef = this.BuildComponent(element, DashboardVolComponent, 'purple', '', 'AVG TRANSACTIONS & VOLUME');
					cRef.instance.bindingContext = this.avgTransContext;
					this.componentsReferences.push(cRef);
					break;
				}
				case 8: { // PENDING APPROVALS WIDGET
					const cRef = this.BuildComponent(element, DashboardPendAppComponent, 'darkblue');
					cRef.instance.bindingContext = this.pendAppBindingContext;
					this.componentsReferences.push(cRef);
					break;
				}
				case 9: { // TOP PERFORMERS WIDGET
					const cRef = this.BuildComponent(element, DashboardTopPerfComponent, 'darkgrey');
					cRef.instance.bindingContext = this.topPerfBindingContext;
					this.componentsReferences.push(cRef);
					break;
				}
				case 17: { // Active Residuals Widget
					const cRef = this.BuildComponent(element, DashboardActiveResidualsComponent, 'darkblue');
					this.componentsReferences.push(cRef);
					break;
				}
				case 18: { // Residuals Outlook Widget
					const cRef = this.BuildComponent(element, DashboardResidualsOutlookComponent, 'white');
					this.componentsReferences.push(cRef);
					break;
				}
				case 19: { // Processing Results Widget
					const cRef = this.BuildComponent(element, DashboardProcessingResultsComponent, 'evowhite');
					this.componentsReferences.push(cRef);
					break;
				}
				default: {

					break;
				}
			}
		});
	}

	/**
	 *
	 * @param element Dashboard Card Element with info
	 * @param c Class type to create component instance of
	 * @param optionalColor Optional card color
	 * @param optionalURL Optional URL route (unused as far as i know)
	 * @param optionalTitle Optional card title (default is element.CardTitle)
	 */
	BuildComponent(element: DashboardCardsList, c: any, optionalColor = '', optionalURL = '', optionalTitle = ''): any {
		const componentFactory = this.CFR.resolveComponentFactory(c);
		const componentRef: any = this.VCR.createComponent(componentFactory);
		if (optionalTitle === '') {
			componentRef.instance.title = element.CardTitle;
		} else {
			componentRef.instance.title = optionalTitle;
		}
		componentRef.location.nativeElement.setAttribute('id', element.CardTitle.replace(' ', '_'));
		componentRef.location.nativeElement.setAttribute('data-cardid', element.CardID.toString());
		if (element.Hidden !== undefined && element.Hidden === true) {
			componentRef.location.nativeElement.classList.add('doNotDisplay');
		}
		componentRef.instance.color = optionalColor;
		componentRef.instance.url = optionalURL;
		componentRef.instance.index = ++this.index;
		return componentRef;
	}

	public getRandomColors(num: number = 1): string[] {
		const allowedColors = [
			'#1BAE99', // green
			'#33488D', // dark blue
			'#6C8CC8', // light blue
			'#58585A', // dark grey
			'#99A0A5', // light grey
			'#5E2D8D', // purple
			'#ff0000' // red
		];
		const colors = [];
		while (colors.length < num) {
			const newColor =
				allowedColors[Math.floor(Math.random() * allowedColors.length)];
			// make sure there aren't adjoining colors
			if (colors.length === 0 || newColor !== colors[colors.length - 1]) {
				colors.push(newColor);
			}
		}
		// console.log(colors)
		return colors;
	}

	UpdateState(CardID: number, HiddenTF: boolean, DisplayOrder: number) {
		const toUpdate: DashboardOrder = new DashboardOrder();
		toUpdate.CardID = CardID;
		toUpdate.Hidden = HiddenTF;
		toUpdate.DisplayOrder = DisplayOrder;
		this.dbSvc.UpdateDashboardItem(toUpdate).toPromise().then(resp => {
			console.log('Saved dbcard state: ', toUpdate);
			this.getDashboardCards(true);
		}).catch(resp => {
			console.error(resp);
			alert('Failed to save dashboard, please try again.');
		});
	}

	onAttritionClick() { }

	get showApplications(): boolean {
		return this.userSvc.canBoard;
	}

	getDashboardCards(refreshCache = false) {
		this.dbSvc.getDashboardItems('ESP', refreshCache).toPromise().then(resp => {
			if (!refreshCache) {
				this.dbCards = resp;
				this.BuildDynamicDashboard();
			}
		});
	}
}
